export const getCurrentPage = ({ offset, limit }: { offset: number; limit: number }) => {
  if (!limit) return 0;

  return Math.floor(offset / limit) + 1;
};
